import React, { Component } from 'react';
import { Grid, TransitionablePortal, Message, Header } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { colorsModeUI } from '../modeUI';
import './index.css';
import {
  FEEDBACK_COLOR,
  FEEDBACK_COLOR_INVERTED,
  ALARM_COLOR,
  ALARM_COLOR_INVERTED,
  POSITIVE_COLOR,
  POSITIVE_COLOR_INVERTED,
} from '../colors';

const TYPE_FEEDBACK = 'feedback';
const TYPE_ERROR = 'error';
const TYPE_OK = 'ok';

const colors = {
  [TYPE_FEEDBACK]: {
    backgroundColor: FEEDBACK_COLOR,
    color: FEEDBACK_COLOR_INVERTED,
  },
  [TYPE_ERROR]: { backgroundColor: ALARM_COLOR, color: ALARM_COLOR_INVERTED },
  [TYPE_OK]: {
    backgroundColor: POSITIVE_COLOR,
    color: POSITIVE_COLOR_INVERTED,
  },
};

/* const integer millisecondsShowSnackbar: miliseconds that the snackbar/message will be show */
const millisecondsShowSnackbar = 3000;
const millisecondsShowSnackbarAlarm = 5000;
/* const integer durationAnimation miliseconds until the snackbar is showed */
const durationAnimation = 2000;
/* const string animation type of animation */
const animation = 'fade down';

/**
 * Dialog/Message component to provide brief feedback about an operation through a message
 * at the bottom of the screen
 *
 * @param string header
 * @param string message
 * @param bool openSnackbar
 * @param string type: [error, ok, feedback] this values determines the backgroud color of it
 * @param function closeSnackbar
 */
export default class Snackbar extends Component {
  constructor(props) {
    super(props);
    this.handleOpen = this.handleOpen.bind(this);
    this.close = this.close.bind(this);
    let { message } = props;
    if (typeof message === 'object') {
      message = message.toString();
    }
    this.state = {
      message,
      header: props.header,
      openSnackbar: props.openSnackbar,
      type: props.type,
      close: false,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let { message } = nextProps;
    if (typeof message === 'object') {
      message = JSON.stringify(message);
    }
    let { openSnackbar } = nextProps;
    if (nextState.close) {
      openSnackbar = false;
    }

    return {
      message,
      openSnackbar,
      header: nextProps.header,
      type: nextProps.type,
      close: false,
    };
  }

  /**
   * Handle open
   * this function keeps open the snack bar message
   * if the message is error then the snackbar should be shown longer
   */
  handleOpen() {
    const { type } = this.state;
    const timeShowSnackbar =
      type === 'error'
        ? millisecondsShowSnackbarAlarm
        : millisecondsShowSnackbar;
    setTimeout(() => {
      this.close();
    }, timeShowSnackbar);
  }

  close() {
    this.setState({
      openSnackbar: false,
      close: true,
    });
    const { closeSnackbar } = this.props;
    closeSnackbar();
  }

  render() {
    const { openSnackbar, header, message } = this.state;
    const { mode } = this.props;

    let { type } = this.state;
    if (type !== 'error' && type !== 'ok') {
      type = 'feedback';
    }
    const styleContainer = {
      backgroundColor: colors[type].backgroundColor,
      color: colors[type].color,
    };

    if (mode !== null) {
      const colorsMode = colorsModeUI(mode);
      if (type === TYPE_FEEDBACK) {
        styleContainer.backgroundColor =
          colorsMode.BACKGROUND_COLOR_SNACKBAR_FEEDBACK;
        styleContainer.color = colorsMode.COLOR_SNACKBAR_FEEDBACK;
      } else if (type === TYPE_ERROR) {
        styleContainer.backgroundColor =
          colorsMode.BACKGROUND_COLOR_SNACKBAR_NEGATIVE;
        styleContainer.color = colorsMode.COLOR_SNACKBAR_NEGATIVE;
      } else {
        styleContainer.backgroundColor =
          colorsMode.BACKGROUND_COLOR_SNACKBAR_POSITIVE;
        styleContainer.color = colorsMode.COLOR_SNACKBAR_POSITIVE;
      }
    }

    return (
      <TransitionablePortal
        open={openSnackbar}
        transition={{ animation, durationAnimation }}
        onOpen={this.handleOpen}
        onClose={this.close}
      >
        <Message className="snackbar-feedback" style={styleContainer}>
          <Grid verticalAlign="middle">
            <Grid.Column textAlign="justified">
              {header ? <Header>{header}</Header> : ''}
              <p>{message}</p>
            </Grid.Column>
          </Grid>
        </Message>
      </TransitionablePortal>
    );
  }
}

Snackbar.propTypes = {
  header: PropTypes.string,
  message: PropTypes.string,
  openSnackbar: PropTypes.bool,
  type: PropTypes.string,
  closeSnackbar: PropTypes.func.isRequired,
  mode: PropTypes.string,
};

Snackbar.defaultProps = {
  header: '',
  message: '',
  type: 'feedback',
  openSnackbar: false,
  mode: null,
};
